import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Inter Light";
        src: url("/fonts/inter-light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Inter Bold";
        src: url("/fonts/inter-bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Inter Light', sans-serif;
    }


        body {
        margin:0;
        padding:0;
        padding-top: 50px; /* Espacio para el header */
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
        
        @media only screen and (max-width: 1024px) {
            padding-top: 100px;
        }
        
        @media only screen and (max-width: 890px) {
            padding-top: 110px; /* Más espacio en móviles */
        }
        
        @media only screen and (max-width: 768px) {
            padding-top: 120px;
        }
        
        @media only screen and (max-width: 480px) {
            padding-top: 130px; /* Aún más espacio en pantallas muy pequeñas */
        }
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Inter Bold', sans-serif;
        color:rgb(0, 0, 0);
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color:rgb(0, 0, 0);
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
